import { Icon } from '@natera/material/lib/icon'
import { Textfield } from '@natera/material/lib/textfield'
import { debounce } from 'lodash-es'
import { useCallback, useEffect, useState } from 'react'
import { cn } from '~/shared/lib/cn'
import { Tooltip } from '~/shared/ui'
import type { ConsignmentFilters } from '../../model'
import { useFilters } from '../../model'

const debouncedSetFilters = debounce(
  (setFilters: (newFilters: Partial<ConsignmentFilters>) => void, value: string) => {
    setFilters({ assetIdQuery: value })
  },
  500,
)

export function SearchField() {
  const { filters, setFilters, disabledFilters } = useFilters()
  const [localSearchValue, setLocalSearchValue] = useState(filters.assetIdQuery)
  const isDisabled = !!disabledFilters.assetIdQuery

  useEffect(() => {
    setLocalSearchValue(filters.assetIdQuery)
  }, [filters.assetIdQuery])

  const handleSearchChange = useCallback(
    (value: string) => {
      setLocalSearchValue(value)
      debouncedSetFilters(setFilters, value)
    },
    [setFilters],
  )

  const textfield = (
    <Textfield
      className={cn('bg-surface-lowest hover:bg-action-hovered h-12 w-[240px]', {
        'hover:bg-surface-lowest': isDisabled,
      })}
      leadIcon={
        <Icon
          className="text-content-high-emphasis absolute top-1/2 left-0 mr-3 ml-4 -translate-y-1/2"
          children="search"
        />
      }
      materialClearIcon="close"
      clearable
      onClear={() => handleSearchChange('')}
      placeholder="Asset ID"
      value={localSearchValue}
      onChange={(e) => handleSearchChange(e.target.value)}
      outline
      disabled={isDisabled}
    />
  )

  if (isDisabled && disabledFilters.assetIdQuery) {
    return (
      <Tooltip
        content={disabledFilters.assetIdQuery}
        delayDuration={0}
      >
        {textfield}
      </Tooltip>
    )
  }

  return textfield
}
